var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyRedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.90625H2C0.9 0.90625 0.01 1.90991 0.01 3.13661L0 17.5559C0 18.3253 0.35 19.0056 0.88 19.4071L9 25.4402L17.11 19.4071C17.64 19.0056 17.99 18.3253 17.99 17.5559L18 3.13661C18 1.90991 17.1 0.90625 16 0.90625ZM7 17.6318L2 12.0559L3.41 10.4835L7 14.4759L14.59 6.01166L16 7.59521L7 17.6318Z",
    fill: "#fc686f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyRedMarker);
export default __webpack_public_path__ + "static/media/safety-red-marker.c94a3fdf38ef0c2df5b053f2ec1af060.svg";
export { ForwardRef as ReactComponent };